import * as React from "react";
import Box from "@mui/material/Box";
import { toast, Toaster } from "react-hot-toast";
import { styled } from "@mui/material/styles";
import Button from "react-bootstrap/Button";
import SideNav from "../SideNav";
import paymentScreenshot from "../../image/payment.jpeg";

import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import {
  ref as refDb,
  get,
  update,
  set,
} from "firebase/database";
import { getDownloadURL, ref as refStorage, uploadBytesResumable } from "firebase/storage";
import { database, storage } from "../../Firebase/firebase.config";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const FONT_STACK = "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif";

const Payment = () => {
  const { id } = useParams();
  const history = useHistory();

  const [subscriptionPaid, setSubscriptionPaid] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [qrImage, setQrImage] = useState(null);
  const [qrUploadUrl, setQrUploadUrl] = useState("");
  const [qrUploading, setQrUploading] = useState(false);
  const [qrUploaded, setQrUploaded] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const snapshot = await get(refDb(database, `doctor/${id}`));
        if (snapshot.exists()) {
          const data = snapshot.val();
          setSubscriptionPaid(data.subscriptionStatus === "paid");
        }
      } catch (error) {
        console.error("Failed to load doctor data:", error);
        toast.error("Unable to load payment data. Please refresh or contact support.");
        return;
      }

      try {
        const qrSnapshot = await get(refDb(database, `QR/doctor/${id}/PaymentQR`));
        if (qrSnapshot.exists()) {
          const qrData = qrSnapshot.val();
          setQrUploadUrl(qrData.url || "");
          setQrUploaded(Boolean(qrData.url));
        }
      } catch (error) {
        console.error("Failed to load QR payment data:", error);
        toast.error("Unable to load QR upload info. You can still continue after uploading.");
      }
    };
    loadData();
  }, [id]);

  const handleConfirmPayment = async () => {
    if (subscriptionPaid) {
      history.push(`/Schedule/${id}`);
      return;
    }

    setIsProcessing(true);
    try {
      await update(refDb(database, `doctor/${id}`), {
        subscriptionStatus: "paid",
        subscriptionAmount: 1200,
        subscriptionPlan: "yearly",
        subscriptionDate: new Date().toISOString(),
      });
      setSubscriptionPaid(true);
      toast.success("Payment confirmed! Redirecting to schedule...");
      setTimeout(() => history.push(`/Schedule/${id}`), 1400);
    } catch (error) {
      toast.error("Payment confirmation failed. Try again.");
      console.error(error);
      setIsProcessing(false);
    }
  };

  const handleQrUpload = async () => {
    if (!qrImage) {
      toast.error("Please select your QR code image first.");
      return;
    }

    setQrUploading(true);
    try {
      const imgRef = refStorage(storage, `QR/doctor/${id}/PaymentQR`);
      const uploadTask = uploadBytesResumable(imgRef, qrImage);

      uploadTask.on(
        "state_changed",
        null,
        (error) => {
          console.error(error);
          toast.error("QR upload failed. Please try again.");
          setQrUploading(false);
        },
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          await set(refDb(database, `QR/doctor/${id}/PaymentQR`), { url });
          setQrUploadUrl(url);
          setQrUploaded(true);
          setQrUploading(false);
          toast.success("QR code uploaded successfully. You can continue to article.");
        }
      );
    } catch (error) {
      console.error(error);
      toast.error("QR upload failed. Please try again.");
      setQrUploading(false);
    }
  };

  const handleContinueToArticle = () => {
    history.push(`/Article/${id}`);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <SideNav id={id} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          minHeight: "100vh",
          paddingTop: "40px",
          boxSizing: "border-box",
        }}
      >
        <DrawerHeader />
        <Toaster toastOptions={{ duration: 3000 }} />

        <div
          style={{
            width: "100%",
            maxWidth: "760px",
            background: "#effcff",
            padding: "2rem",
            borderRadius: "22px",
            boxShadow: "0 18px 40px rgba(12, 75, 105, 0.12)",
            fontFamily: FONT_STACK,
            boxSizing: "border-box",
            border: "1px solid rgba(15, 118, 160, 0.18)",
          }}
        >
          <div style={{ display: "grid", gap: "1rem" }}>
            <div style={{ textAlign: "center" }}>
              <h2 style={{ color: "#0f5f82", fontWeight: 700, marginBottom: "0.25rem" }}>
                Subscription Payment
              </h2>
              <p style={{ color: "#2e4d5b", lineHeight: 1.6, margin: 0 }}>
                Pay ₹1200/year to activate your doctor listing and continue to schedule setup.
              </p>
            </div>

            <div
              style={{
                background: "#e6f7f6",
                borderRadius: "18px",
                padding: "1.25rem 1.3rem",
                border: "1px solid rgba(18, 149, 155, 0.18)",
                display: "grid",
                gap: "1rem",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "0.7rem" }}>
                <span style={{ fontSize: "0.86rem", fontWeight: 700, letterSpacing: "0.04em", color: "#0a6a70" }}>
                  per Year Subscription
                </span>
                <div style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
                  <span style={{ fontSize: "2rem", fontWeight: 800, color: "#0c6f7f" }}>
                    ₹1,200
                  </span>
                  <span style={{ fontSize: "1rem", fontWeight: 700, color: "#0c6f7f" }}>
                    Rupees One Thousand & Two Hundred only
                  </span>
                </div>
                <span style={{ fontSize: "0.95rem", color: "#376c7a" }}>
                  Recurs each year. One-time payment unlocks schedule creation.
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gap: "1rem",
              }}
            >
              <div
                style={{
                  background: "white",
                  borderRadius: "18px",
                  padding: "1rem",
                  boxShadow: "0 12px 30px rgba(14, 88, 112, 0.08)",
                  border: "1px solid rgba(13,110,253,0.12)",
                }}
              >
                <div style={{ fontWeight: 700, color: "#144f66", marginBottom: "0.75rem", textAlign: "center" }}>
                  Scan to Pay
                </div>
                <img
                  src={paymentScreenshot}
                  alt="Payment scanner screenshot"
                  style={{
                    width: "100%",
                    maxWidth: "380px",
                    display: "block",
                    margin: "0 auto",
                    borderRadius: "16px",
                    border: "1px solid rgba(13,110,253,0.14)",
                  }}
                />
                <div style={{ marginTop: "0.85rem", fontSize: "0.9rem", color: "#3f5f6d", textAlign: "center" }}>
                  Scan the QR code shown in the screenshot photo and pay ₹1,200 (Rupees One Thousand & Two Hundred only) to proceed.
                </div>
              </div>

              <div
                style={{
                  background: "rgba(20, 83, 110, 0.07)",
                  borderRadius: "18px",
                  padding: "1rem 1.1rem",
                }}
              >
                <div style={{ fontWeight: 700, color: "#0d4c63", marginBottom: "0.5rem" }}>
                  Payment status
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "0.75rem", flexWrap: "wrap" }}>
                  <span style={{ fontSize: "0.92rem", color: "#176778" }}>Subscription</span>
                  <span style={{ fontWeight: 700, color: "#0b5566" }}>
                    {subscriptionPaid ? "Paid" : "Pending"}
                  </span>
                </div>
                <p style={{ marginTop: "0.85rem", color: "#31535f", lineHeight: 1.5, fontSize: "0.88rem" }}>
                  Confirm payment after scanning the shown QR screenshot to move to schedule setup.
                </p>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "1rem", flexWrap: "wrap", marginTop: "1.5rem" }}>
              <Button
                variant="success"
                onClick={handleConfirmPayment}
                disabled={isProcessing}
                style={{ minWidth: "170px", padding: "0.95rem 1.25rem", fontWeight: 700, background: "#0d9f94", borderColor: "#0c8b84" }}
              >
                {subscriptionPaid ? "Paid ✔" : isProcessing ? "Confirming…" : "Confirm Payment"}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => history.push(`/Schedule/${id}`)}
                disabled={!subscriptionPaid}
                style={{ minWidth: "170px", padding: "0.95rem 1.25rem", fontWeight: 700, color: "#0d6efd", borderColor: "#0d6efd" }}
              >
                Go to Schedule
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default Payment;